/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/410-renren': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.644.166C2.875.8 0 4.079 0 8.028a7.96 7.96 0 001.887 5.15c2.791-1.35 4.744-4.406 4.756-7.966V.165zM9.356.166C13.125.8 16 4.079 16 8.028a7.96 7.96 0 01-1.887 5.15c-2.791-1.35-4.744-4.406-4.756-7.966V.165zM7.972 10.041c-.497 2.056-1.981 3.813-3.828 4.981 1.138.622 2.441.978 3.828.978s2.691-.356 3.828-.978c-1.847-1.169-3.331-2.925-3.828-4.981z"/>'
  }
})
